import { render, staticRenderFns } from "./specialList.vue?vue&type=template&id=7b45f64e&scoped=true"
import script from "./specialList.vue?vue&type=script&lang=js"
export * from "./specialList.vue?vue&type=script&lang=js"
import style0 from "./specialList.vue?vue&type=style&index=0&id=7b45f64e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45f64e",
  null
  
)

export default component.exports